import { FC, FunctionComponent } from 'react';

type Props = {
  layout: FunctionComponent<any>;
  page: FunctionComponent<any>;
};

// From RouteWithLayout to WrappedPage
// https://stackoverflow.com/questions/69864165/error-privateroute-is-not-a-route-component-all-component-children-of-rou
const WrappedPage: FC<Props> = ({ layout: Layout, page: Page }) => (
  <Layout>
    <Page />
  </Layout>
);

export default WrappedPage;
